import { ConceptValueDataType, RenderMedia } from "@fusion-advantage/backcompat"
import { useFormSelector } from "../../../redux/formStoreHooks"
import { selectExport } from "../../../redux/selectForm"
import { L4DiagnosisClinicianReview } from "./L4DiagnosisClinicianReview"
import L4SecondaryCodingTable from "./L4SecondaryCodingTable"
import { DiagnosisReviewConcept, DiagnosisReviewMode, formDiagnosisReviewMode } from "@fusion-advantage/formlib"
import L4DiagnosisAuditReview from "./L4DiagnosisAuditReview"
import { useConceptValidator } from "./useConceptValidator"

export const L4DiagnosisReview = () => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4DiagnosisReview',
		cid: DiagnosisReviewConcept.cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.Object],
	})
	const media = useFormSelector(state => state.render.media)
	const codeNext = useFormSelector(state => selectExport(state)?.Form.Encounter.CodeNext)
	if(errorNode) {
		return errorNode
	}
	if(media === RenderMedia.Print) {
		return (
			<>
				<L4DiagnosisClinicianReview />
				<L4SecondaryCodingTable />
			</>
		)
	}
	if(codeNext && (formDiagnosisReviewMode(codeNext) === DiagnosisReviewMode.Auditor)) {
		return <L4DiagnosisAuditReview />
	}
	return <L4DiagnosisClinicianReview />
}
